import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logoFooter from '../../assets/images/logos/JG Printing Tagline_footer.png';

/**
 * Footer component for the JG Printing website.
 * Contains logo, navigation links, and social media icons.
 */
function Footer() {
    const footerLinks = [
        { label: 'How to Order', to: '/how-to-order' },
        { label: 'About Us', to: '/about-us' },
        { label: 'FAQs', to: '/faqs' },
        { label: 'Privacy & Policy', to: '/privacy-policy' },
        { label: 'Terms & Conditions', to: '/terms-and-conditions' }
    ];

    const socialLinks = [
        {
            href: 'https://www.facebook.com/jgdigitalprinting',
            label: 'Facebook',
            icon: <FacebookIcon />
        },
        {
            href: 'https://www.tiktok.com/@jgprints09?_t=8coub7aAbPW&_r=1&fbclid=IwY2xjawQWQFZleHRuA2FlbQIxMABicmlkETFHWUFjaFVrY0VqV3RBTUNPc3J0YwZhcHBfaWQQMjIyMDM5MTc4ODIwMDg5MgABHgzC3m14eCLdN__yjva2vczD7lre0G7rxLpQ1KMTR2bk0YqKc_Dg2NyF8X_t_aem_WsKXvLlIVVmUrLQcG2SHkQ',
            label: 'TikTok',
            icon: <TikTokIcon />
        },
        {
            href: 'https://www.lazada.com.ph/shop/jg-digital-printing/?spm=a2o4l.pdp_revamp.seller.1.79fa158dTUoVaL&itemId=3791229850&channelSource=pdp&fbclid=IwY2xjawQWQFRleHRuA2FlbQIxMABicmlkETFHWUFjaFVrY0VqV3RBTUNPc3J0YwZhcHBfaWQQMjIyMDM5MTc4ODIwMDg5MgABHo1lDVICSMF-f151V9F-4dh1XUiELq0R8rKCPn8uIu9xqSa9Js_0pU0tNmsr_aem_xA-Dkkm56vElSreOnEW9Iw',
            label: 'Lazada',
            icon: <LazadaIcon />
        },
        {
            href: 'https://www.youtube.com/@JGalangVlogs',
            label: 'YouTube',
            icon: <YoutubeIcon />
        }
    ];

    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-logo">
                    <img 
                        src={logoFooter} 
                        alt="JG Printing - Quality and Affordable Since 2019" 
                        className="footer-logo-image"
                    />
                </div>

                <div className="footer-links-container">
                    <div className="footer-links-divider"></div>
                    <nav className="footer-links">
                        <div className="footer-links-row">
                            {footerLinks.slice(0, 3).map((link, index) => (
                                <Link key={index} to={link.to} className="footer-link">
                                    {link.label}
                                </Link>
                            ))}
                        </div>
                        <div className="footer-links-row">
                            {footerLinks.slice(3).map((link, index) => (
                                <Link key={index} to={link.to} className="footer-link">
                                    {link.label}
                                </Link>
                            ))}
                        </div>
                    </nav>
                </div>

                <div className="footer-social">
                    {socialLinks.map((social, index) => (
                        <a
                            key={index}
                            href={social.href}
                            className="social-link"
                            aria-label={social.label}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {social.icon}
                        </a>
                    ))}
                </div>
            </div>
        </footer>
    );
}

/* SVG Icon Components */
function FacebookIcon() {
    return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
        </svg>
    );
}

function TikTokIcon() {
    return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.75a4.85 4.85 0 01-1.01-.06z"/>
        </svg>
    );
}

function LazadaIcon() {
    return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm4.5 14.5h-9a.5.5 0 01-.5-.5V8a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v6.5h6.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5z"/>
        </svg>
    );
}

function YoutubeIcon() {
    return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
            <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
    );
}

export default Footer;